export enum OcadoEnvironment {
    LOCAL = 'local',
    DEV = 'dev',
    TST = 'tst',
    PPD = 'ppd',
    PROD = 'prod'
  }
  export const SNACKBAR_DURATION = 4000;